<template>
  <div class="row blaPrologueContainer">
    <ProgressBar
      :max-position="maxPosition"
      :current-position="currentPosition"
      :show="false"
      :fixed-header="true"
    />
    <div class="col-10 offset-1 col-md-10 offset-md-1">
      <div class="row mt-5 mb-2">
        <div class="col-2 text-right">
          <img
            :src="require('@/assets/img/exclamation_mark_icon.png')"
            alt="exclamation_mark_icon"
            class="blaExlaminationIcon"
          />
        </div>
        <div class="col-10 blaPrologueTitle">
          Nézz meg egy rövid részletet a videóból a gyakorlás előtt és után!
          (max. 50 másodperc)
        </div>
      </div>
    </div>
    <div class="col-10 offset-1 col-md-8 offset-md-2">
      <div class="row text-center mt-4 mb-2">
        <div
          v-if="video.filename !== null && video.filename.length > 0"
          class="col-12"
        >
          <video
            v-if="video.filename !== null && video.filename.length > 0"
            controls
            controlsList="nodownload"
            preload="metadata"
            webkit-playsinline="true"
            playsinline="true"
            :poster="coverImage"
            class="blaPrologueVideo"
          >
            <source
              :src="
                this.$store.getters.getApiUrl +
                '/uploads/video/' +
                video.filename
              "
              type="video/mp4"
            />
            <source
              :src="
                this.$store.getters.getApiUrl +
                '/uploads/video/' +
                video.filename
              "
              type="video/ogg"
            />
            <source
              :src="
                this.$store.getters.getApiUrl +
                '/uploads/video/' +
                video.filename
              "
              type="video/webm"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <div v-if="youtube.show && youtube.url.length > 0" class="col-12">
          <!-- Youtube video -->
          <div v-if="youtube.url !== null && youtube.url.length > 0">
            <LazyYoutubeVideo
              :src="'https://www.youtube.com/embed/' + youtube.url"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-10 offset-1 col-md-2 offset-md-5">
      <div class="blaPrologueNextButton p-3 clickable" @click="goToNext">
        Következő
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ProgressBar from "@/components/partials/ProgressBar";
import LazyYoutubeVideo from "vue-lazy-youtube-video";

export default {
  components: {
    ProgressBar,
    LazyYoutubeVideo,
  },
  data: () => ({
    lessonId: "",
    lesson: {},
    apiUrl: "",
    maxPosition: 0,
    video: {
      filename: "",
      title: "",
    },
    youtube: {
      url: "",
      show: false,
    },
    coverImage: "",
    currentPosition: 0,
  }),
  methods: {
    getPrologueData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/lesson/prologue/load", {
          token: this.$store.getters.getToken,
          lessonId: this.$data.lessonId,
        })
        .then((response) => {
          if (response.data.video !== null) {
            this.video.filename = response.data.video.filename;
            this.video.title = response.data.video.title;
          }

          if (response.data.youtubeUrl !== null) {
            this.youtube.url = response.data.youtubeUrl;
            this.youtube.show = true;
          }

          //Store the lesson data
          this.lesson = response.data.lesson;

          //Inspect the cover image
          if (
            this.lesson.file.length > 1 &&
            this.lesson.file &&
            this.lesson.file.filename
          ) {
            this.coverImage =
              this.$store.getters.getApiUrl + "/" + this.lesson.file.filename;
          } else {
            this.coverImage = require("@/assets/img/bla_play_button.png");
          }
        })
        .catch((error) => {
          console.log("prologue - error: ", error);
        });
    },
    goToNext() {
      //Check it is a test+video or not
      if (this.lesson.type == 3) {
        //Just push to the test & client do the test
        this.$router.push({
          name: "test",
          params: { lessonId: this.lesson.id },
        });
      } else if (this.lesson.type == 4) {
        //If fromLingron undefined, the client now start the test
        if (this.$route.params.fromLingron === undefined) {
          this.$router.push({
            name: "test",
            params: { lessonId: this.lesson.id },
          });
        } else {
          //fromLingron exists, the client finished the test and go to the summary
          this.$router.push({
            name: "selfValue",
            params: { lessonId: this.lesson.id },
          });
        }
      } else {
        if (this.$route.params.fromLingron === undefined) {
          this.$router.push({
            name: "lingron",
            params: { lessonId: this.lesson.id },
          });
        } else {
          this.$router.push({
            name: "selfValue",
            params: { lessonId: this.lesson.id },
          });
        }
      }
    },
  },
  mounted: function () {
    this.lessonId = this.$store.getters.currentLessonId;
    this.apiUrl = this.$store.getters.getApiUrl;

    //Set progressbar inficator
    if (this.$route.params.fromLingron === undefined) {
      this.currentPosition = 10;
    } else {
      this.currentPosition = 90;
    }

    this.getPrologueData();
  },
};
</script>
